<template>
  <div class="copyrights-block">
    <span>{{ $t('header.copyrights.textLeft') }}</span>&nbsp;<a
      target="_blank"
      :href="copyrightsLink">{{ $t('header.copyrights.textLink') }}</a>&nbsp;&nbsp;<span
      class="copyrights-block__years">{{ $t('header.copyrights.textYears', { currentYear }) }}</span><span
      class="copyrights-block__reserved">&comma;&nbsp;{{ $t('header.copyrights.textRight') }}</span>
  </div>
</template>

<script>
import copyrights from '../../../config/copyrights';

export default {
  name: 'CopyrightsBlock',
  data() {
    return {
      copyrightsLink: copyrights.link,
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  }
}
</script>

<style lang="scss">
.copyrights-block,
.copyrights-block a {
  font-size: 0.75rem;
  line-height: 0.75rem;
}

.copyrights-block {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 0.375rem;
  white-space: nowrap;
  overflow-x: visible;

  a {
    font-weight: 600;
  }

  &__years {
    font-size: 0.67rem;
    font-weight: 500;
  }
}

@include smallerThan("md") {
  .copyrights-block__reserved {
    display: none;
  }
}

</style>
